export const COUNTRY_CODE = {
  US: 1,
}

export const PASSWORD_MIN_LENGTH = 8
